module.exports = __webpack_public_path__ + "img/bank_11.8eb64222.png";